import * as React from 'react';
import { memo } from 'react';

const SvgSpeakerHigh = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.375 9.188H1.75a.438.438 0 0 1-.438-.438v-3.5a.438.438 0 0 1 .438-.438h2.625L8.313 1.75v10.5L4.374 9.187ZM4.375 4.813v4.375M10.424 5.764a1.745 1.745 0 0 1 0 2.472M11.971 4.216a3.931 3.931 0 0 1 0 5.567", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgSpeakerHigh);

export { Memo as default };
